import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';
import Coding from './types/Coding';

export default class BN_SuperBillLineItemModifier extends BackboneElement {
    static __className = 'BN_SuperBillLineItemModifier';

    __objectStructure = {
        code: Coding,
        position: Number,
    };

    constructor(constructJson, className = 'BN_SuperBillLineItemModifier') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
